import { API_CONFIG, apiUtils } from '../config.js';

// Section Management API
export const sectionApi = {
  // Get all sections for a specific unit
  getSectionsByUnit: async (unitId) => {
    const url = `${API_CONFIG.BASE_URL}/section/unit/${unitId}`;
    return apiUtils.makeAuthenticatedRequest(url);
  },
};

export default sectionApi;
